import CompanyProfilePanel from "./CompanyProfilePanel";
import ChatPanel from "./ChatPanel";
import "./tradingDashboard.css";

export default function RightSidebar({
  selectedCompany,
  setSelectedCompany,
  activeTab,
  setWindowState,
  onClose,
  messages,
  addNotification,
  onSelectedPlayer,
  setSelectedPlayer,
  userData
}) {

  const currentTab = (activeTab || "").toLowerCase();

  const isPanelOpen = 
    currentTab.includes("contract") || 
    currentTab.includes("my company") || 
    (selectedCompany !== null && currentTab.includes("company"));

  return (
    <aside 
      id="v2-right-sidebar-anchor" 
      style={{ 
        height: '100%', 
        width: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        background: '#0d1615',
        overflow: 'hidden',
        position: 'relative', 
        borderLeft: '1px solid rgba(80, 227, 194, 0.2)'
      }}
    >
      <div className="scanlines" style={{ pointerEvents: 'none' }} />

      {/* 1. PROFILE AREA */}
      <div 
        className="v2-profile-outer-container"
        style={{ 
          flex: 1, 
          width: '100%', 
          display: 'flex', 
          flexDirection: 'column',
          overflowY: 'auto', 
          minHeight: 0,
          background: 'transparent',
          zIndex: 1
        }}
      >
        <CompanyProfilePanel
          company={selectedCompany}
          activeTab={activeTab}
          setWindowState={setWindowState}
          setSelectedCompany={setSelectedCompany}
          onClose={onClose}
          addNotification={addNotification}
          setSelectedPlayer={setSelectedPlayer}
        />
      </div>

      {/* 2. CHAT AREA */}
      <div 
        className="v2-chat-anchored-wrapper"
        style={{ 
          position: 'relative', 
          width: '100%', 
          height: isPanelOpen ? '350px' : '650px', 
          transition: 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          background: 'rgba(13, 22, 21, 0.9)', 
          borderTop: '2px solid rgba(80, 227, 194, 0.4)',
          display: 'flex',
          flexDirection: 'column',
          flexShrink: 0,
          zIndex: 10,
        }}
      >
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
          <ChatPanel
            messages={messages}
            onSelectedPlayer={onSelectedPlayer}
            onClose={() => setSelectedPlayer(null)}
          />
        </div>
      </div>
    </aside>
  );
}